import type { ReactNode, ComponentPropsWithoutRef, Ref } from 'react';
import { Link } from 'src/navigation';
import cn from 'classnames';
import GTMLink, {
	type GTMLinkAnalyticsProps,
} from 'components/controls/links/GTMLink';
import styles from './link-button.module.scss';

type LinkButtonProps = ComponentPropsWithoutRef<typeof Link> & {
	analytics?: GTMLinkAnalyticsProps;
	leftIcon?: ReactNode;
	ref?: Ref<HTMLAnchorElement>;
	rightIcon?: ReactNode;
	text?: string;
};

const LinkButton = ({
	analytics,
	text,
	href,
	ref,
	rightIcon,
	leftIcon,
	...remainingProps
}: LinkButtonProps) => {
	const content = (
		<>
			{leftIcon}
			{text}
			{rightIcon}
		</>
	);

	if (analytics) {
		return (
			<GTMLink
				{...remainingProps}
				href={href}
				ref={ref}
				{...analytics}
				className={cn(styles.linkButton, remainingProps.className)}
			>
				{content}
			</GTMLink>
		);
	}

	return (
		<Link
			{...remainingProps}
			href={href}
			ref={ref}
			className={cn(styles.linkButton, remainingProps.className)}
		>
			{content}
		</Link>
	);
};

export default LinkButton;
